import React from 'react';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://apiqldangkyxe.nguyenluan.vn';

const VehicleStatisticTable = ({ data, vehicleCategory, userRole, onEdit, onDelete, onViewImages, page, limit }) => {
  return (
    <div className="table-responsive">
      <table className="data-table">
        <thead>
          <tr>
            <th>STT</th>
            <th>Biển số</th>
            <th>Tên chủ sở hữu/SĐT</th>
            <th>Địa chỉ chủ sở hữu</th>
            <th>Tên người sử dụng/SĐT</th>
            <th>Địa chỉ người sử dụng</th>
            
            {vehicleCategory !== 'PASSENGER_NO_YELLOW' && (
              <>
                <th>Tên người điều khiển/SĐT</th>
                <th>Địa chỉ người điều khiển</th>
              </>
            )}

            <th>
              {vehicleCategory === 'PASSENGER_NO_YELLOW' || vehicleCategory === 'WORKER_MOTO'
                ? 'Nguồn gốc xe'
                : 'Nguồn gốc mua xe'}
            </th>

            {vehicleCategory === 'DUMP_TRUCK' && (
              <>
                <th>Hoán cải phương tiện</th>
                <th>Cơi nới thành thùng</th>
                <th>Màu biển</th>
                <th>Vị trí lắp biển số</th>
                <th>Độ chế còi đèn</th>
                <th>Niên hạn sử dụng</th>
                <th>GSHT & Ghi hình</th>
              </>
            )}

            {vehicleCategory === 'LIMOUSINE' && (
              <>
                <th>Số chỗ theo KĐ</th>
                <th>Số chỗ thực tế</th>
                <th>Dấu hiệu cải tạo</th>
                <th>Màu biển</th>
                <th>GSHT & Ghi hình</th>
              </>
            )}

            {vehicleCategory === 'PASSENGER_NO_YELLOW' && (
              <>
                <th>Dấu hiệu KDVT</th>
                <th>Đã đổi biển vàng</th>
                <th>Nguồn thông tin rà soát</th>
              </>
            )}

            {vehicleCategory === 'WORKER_MOTO' && (
              <>
                <th>Loại xe/Nhãn hiệu</th>
                <th>Tình trạng phương tiện</th>
                <th>Thực trạng quản lý SD</th>
              </>
            )}

            <th>Cán bộ thu thập/Đơn vị</th>
            <th>Ghi chú</th>
            <th style={{ minWidth: '100px' }}>Thao tác</th>
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan="20" className="no-data">Không có dữ liệu</td>
            </tr>
          ) : (
            data.map((item, index) => (
              <tr key={item.id}>
                <td style={{ textAlign: 'center' }}>{(page - 1) * limit + index + 1}</td>
                <td className="license-plate-cell">{item.licensePlate}</td>
                <td>{item.ownerNamePhone}</td>
                <td className="text-ellipsis-sm" title={item.ownerAddress}>{item.ownerAddress}</td>
                <td>{item.currentUserNamePhone}</td>
                <td className="text-ellipsis-sm" title={item.currentUserAddress}>{item.currentUserAddress}</td>
                
                {vehicleCategory !== 'PASSENGER_NO_YELLOW' && (
                  <>
                    <td>{item.driverNamePhone}</td>
                    <td className="text-ellipsis-sm" title={item.driverAddress}>{item.driverAddress}</td>
                  </>
                )}

                <td className="text-ellipsis-sm" title={item.origin}>{item.origin}</td>

                {vehicleCategory === 'DUMP_TRUCK' && (
                  <>
                    <td>{item.isModified}</td>
                    <td>{item.isExtended}</td>
                    <td>{item.plateColor}</td>
                    <td>{item.platePosition}</td>
                    <td>{item.hasModifiedLightsHorn}</td>
                    <td>{item.usageExpiry}</td>
                    <td>
                      {item.hasMonitoringDevice ? (
                        <span title={`TK: ${item.monitoringAccount} | MK: ${item.monitoringPassword} | ĐV: ${item.monitoringProvider}`}>
                          ✅ Có
                        </span>
                      ) : (
                        <span>❌ Không</span>
                      )}
                    </td>
                  </>
                )}

                {vehicleCategory === 'LIMOUSINE' && (
                  <>
                    <td style={{ textAlign: 'center' }}>{item.registeredSeats}</td>
                    <td style={{ textAlign: 'center' }}>{item.actualSeats}</td>
                    <td>{item.modificationSigns}</td>
                    <td>{item.plateColor}</td>
                    <td>
                      {item.hasMonitoringDevice ? (
                        <span title={`TK: ${item.monitoringAccount} | MK: ${item.monitoringPassword} | ĐV: ${item.monitoringProvider}`}>
                          ✅ Có
                        </span>
                      ) : (
                        <span>❌ Không</span>
                      )}
                    </td>
                  </>
                )}

                {vehicleCategory === 'PASSENGER_NO_YELLOW' && (
                  <>
                    <td>{item.businessSigns}</td>
                    <td style={{ textAlign: 'center' }}>{item.hasYellowPlate ? '✅ Rồi' : '❌ Chưa'}</td>
                    <td>{item.infoSource}</td>
                  </>
                )}

                {vehicleCategory === 'WORKER_MOTO' && (
                  <>
                    <td>{item.vehicleBrand}</td>
                    <td>{item.ownershipStatus}</td>
                    <td className="text-ellipsis-sm" title={item.usageStatus}>{item.usageStatus}</td>
                  </>
                )}

                <td>{item.collectorNameAndUnit}</td>
                <td className="text-ellipsis-sm" title={item.notes}>{item.notes}</td>
                <td>
                  <div className="action-buttons-cell">
                    <button className="stat-btn-edit" onClick={() => onEdit(item)}>Sửa</button>
                    {(userRole === 'admin' || userRole === 'supervisor') && (
                      <button className="stat-btn-delete" onClick={() => onDelete(item.id)}>Xóa</button>
                    )}
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default VehicleStatisticTable;
